import React, { useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Table, TableBody, TableCell, TableContainer, TableRow, Paper, Switch,
} from '@material-ui/core';
import moment from 'moment';
import EnhancedTableHead from '../../CommonComponents/TableComponents/EnhancedTableHead';
import {
  getComparator,
  stableSort,
} from '../../CommonComponents/TableComponents/TableUtils';
import CommonButton from '../../CommonComponents/CommonButton';
import CommonModal from '../../CommonComponents/CommonModal';
import CommonPasswordField from '../../CommonComponents/CommonPasswordField';
import UpdateUser from '../../CommonComponents/UpdateUser';
import FallbackCard from '../../CommonComponents/FallbackCard';
import { resetPassword } from '../../redux/actions/common';
import { updateVendorUser } from '../../redux/actions/suppliers';
import { formValidation } from '../../Utils';

const headCells = [
  {
    id: 'full_name',
    numeric: false,
    label: 'Username',
  },
  {
    id: 'SupplierName',
    numeric: false,
    label: 'Supplier Name',
  },
  {
    id: 'email',
    numeric: false,
    label: 'Email',
  },
  {
    id: 'mobile',
    numeric: false,
    label: 'Mobile',
  },
  {
    id: 'Reset Password',
    numeric: false,
    label: 'Reset Password',
  },
  {
    id: 'Edit',
    numeric: false,
    label: 'Edit',
  },
  {
    id: 'status',
    numeric: true,
    label: 'Status',
  },
  {
    id: 'updatedAt',
    numeric: false,
    label: 'Last Active',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  title: {
    marginRight: 30,
    marginTop: 12,
    float: 'left',
  },
  assignButtonWidth: {
    width: 250,
  },
}));

const MonitorUserTable = ({ allUsers, changePassword, updateVendor }) => {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('Name');
  const [open, setModal] = useState(false);
  const [password, setPassword] = useState('123');
  const [userID, setUser] = useState(null);
  const [validation, formValidate] = useState(null)
  const [updateUser, setUpdateUser] = React.useState(null)

  const selectUser = (id) => {
    setUser(id)
    setModal(true)
  }
  const changePass = async () => {
    const valid = await formValidation({ password }, 'resetPassword')
    if (valid === undefined) {
      formValidate(null)
      const data = {
        password,
        userType: 'vendorUser',
      }
      changePassword(data, userID)
      setModal(false);
    } else {
      formValidate(valid)
    }
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const user = JSON.parse(localStorage.getItem('user'))
  return (
    <div className={classes.root}>
      <div>
        {allUsers.length > 0
          ? (
            <Paper className={classes.paper}>
              <TableContainer>
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size="medium"
                  aria-label="enhanced table"
                >
                  <EnhancedTableHead
                    headCells={headCells}
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {stableSort(allUsers, getComparator(order, orderBy))
                      .map((row) => (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                        >
                          <TableCell>
                            {row.full_name}
                          </TableCell>
                          <TableCell>
                            {row.supplier && row.supplier.supplierName}
                          </TableCell>
                          <TableCell>
                            {row.email}
                          </TableCell>
                          <TableCell>
                            {row.mobile}
                          </TableCell>
                          <TableCell>
                            <CommonButton
                              variant="outlined"
                              color="primary"
                              onClick={() => selectUser(row.id)}
                              disabled={user.userType === 'supplier'}
                            >
                              Reset Password
                            </CommonButton>
                          </TableCell>
                          <TableCell align="left" padding="none">
                            <CommonButton
                              color="primary"
                              basic="true"
                              onClick={() => setUpdateUser(row)}
                              disabled={user.userType === 'supplier'}
                            >
                              <b>Edit</b>
                            </CommonButton>
                          </TableCell>
                          <TableCell align="left">
                            <Switch
                              checked={row.status}
                              onChange={() => updateVendor({ status: !row.status }, row.id)}
                              color="primary"
                              name="checkedA"
                              inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                          </TableCell>
                          <TableCell>
                            {moment(row.updatedAt).format('DD MMM YYYY, h:mm:ss a')}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          )
          : <FallbackCard text="No data found" />}
      </div>
      {open
        ? (
          <CommonModal
            title="Reset Password"
            width="sm"
            open
            onYes={changePass}
            onClose={() => setModal(false)}
            successButtonText="Reset"
            cancelButtonText="Cancel"
            disableEscapeKeyDown
            disableBackdropClick
          >
            <div className="row">
              <div className="col-12">
                <CommonPasswordField
                  validation={validation ? validation.password : null}
                  handleChange={setPassword}
                />
              </div>
            </div>
          </CommonModal>
        )
        : null }
      {updateUser
        ? <UpdateUser setModal={() => setUpdateUser(null)} user={updateUser} userType="vendor" />
        : null}
    </div>
  );
};

const mapState = (state) => ({
  allUsers: state.suppliers.allUsers,
});

const mapAction = {
  changePassword: resetPassword,
  updateVendor: updateVendorUser,
};

export default connect(mapState, mapAction)(MonitorUserTable);
